import { getValue, getRequiredValue, getBooleanValue } from '@/helpers/settings'
import defaultValues from './defaultValues';
import valuesValidators from './valuesValidators';
import get from 'lodash/get'

export default {
  getValue(path) {
    return getValue(path, this.getDefaultValue(path))
  },

  getRequiredValue(path, defaultValue = null) {
    return getRequiredValue(path, this.getDefaultValue(path, defaultValue))
  },

  getBooleanValue(path, defaultValue = null) {
    return getBooleanValue(path, this.getDefaultValue(path, defaultValue))
  },

  getDefaultValue(path, defaultValue = null) {
    return get(defaultValues, path, defaultValue)
  },

  getValidatedValue(path, value, defaultValue = null) {
    const validator = get(valuesValidators, path, null)

    if (typeof validator !== 'function') {
      return value
    }

    const validated = validator(value)

    if (validated === null) {
      return this.getDefaultValue(path, defaultValue)
    }

    return validated
  }
}
